// extracted by mini-css-extract-plugin
export default {"GateBody":"value_GateBody__TCg2G","SettingsContainer":"value_SettingsContainer__s+QG4","SwitchContainer":"value_SwitchContainer__R86gH"};